// extracted by mini-css-extract-plugin
export default {"card":"CardFrame_card__XJfLF","header":"CardFrame_header__e2BnE","headerTitle":"CardFrame_headerTitle__tKyHh","headerRight":"CardFrame_headerRight__A2nQ3"};